import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import HorsesService from '../../../services/horses.service';
export const initialState = {
    jockeyIndex: 0,
    jockeySkinIndex: -1,
    horseSkinIndex: -1,
    configurator: null,
    pending: false
};
export const configureHorse = createAsyncThunk('configure/id', async (data) => {
    try {
        return await HorsesService.configureHorse(data);
    }
    catch (err) {
        return err.response;
    }
});
export const getHorseConfigurations = createAsyncThunk('configure/assetName', async (horseId) => {
    try {
        return await HorsesService.getHorseConfigurator(horseId);
    }
    catch (err) {
        return err.response;
    }
});
export const getVisitedUsersConfigurations = createAsyncThunk('configure/:userId/assetName', async ({ userId, horseId }) => {
    try {
        return await HorsesService.getVisitedUserConfigurations(userId, horseId);
    }
    catch (err) {
        return err.response;
    }
});
export const removeConfiguratorSettings = createAsyncThunk('configure/id/delete', async (data) => {
    try {
        return await HorsesService.removeConfiguratorSettings(data);
    }
    catch (err) {
        return err.response;
    }
});
export const configurator = createSlice({
    name: 'configurator',
    initialState,
    reducers: {
        setJockeyIndex: (state, { payload }) => {
            state.jockeyIndex = payload;
        },
        setJockeySkinIndex: (state, { payload }) => {
            state.jockeySkinIndex = payload;
        },
        setHorseSkinIndex: (state, { payload }) => {
            state.horseSkinIndex = payload;
        },
        setDeluxeSkinIndex: (state, { payload }) => {
            state.jockeySkinIndex = payload;
            state.horseSkinIndex = payload;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getHorseConfigurations.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.configurator = action.payload.data;
            }
        });
        builder.addCase(configureHorse.fulfilled, (state, action) => {
            state.pending = false;
        });
        builder.addCase(configureHorse.pending, (state, action) => {
            state.pending = true;
        });
        builder.addCase(configureHorse.rejected, (state, action) => {
            state.pending = false;
        });
        builder.addCase(removeConfiguratorSettings.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.configurator = action.payload.data;
            }
        });
        builder.addCase(getVisitedUsersConfigurations.fulfilled, (state, action) => {
            if (action.payload.status === 200) {
                state.configurator = action.payload.data;
            }
        });
    }
});
export const { setJockeyIndex, setJockeySkinIndex, setHorseSkinIndex, setDeluxeSkinIndex } = configurator.actions;
export default configurator.reducer;
